export const getCookie = () => {
  const cookies = decodeURIComponent(document.cookie);
  const cookieArr = cookies.split('; ');
  let cookieJson = {};
  cookieArr.forEach(val => {
    let data = val.split("=");
    cookieJson[data[0]] = data[1];
  })
  return cookieJson
}

export const getToken = () => localStorage.getItem("token");

export const setToken = (token = "") => {
  localStorage.setItem("token", token);
};
export const getRefreshToken = () => localStorage.getItem("refresh-token");

export const setRefreshToken = (refreshtoken = "") => {
  localStorage.setItem("refresh-token", refreshtoken);
};
export const setUserEmailId = (userEmailId = "") => {
  localStorage.setItem("user-email-id", userEmailId);
};

export const getUserEmailId = () => localStorage.getItem("user-email-id")

export const setSessionId = (sessionId = "") => {
  localStorage.setItem("session-id", sessionId);
};

export const getSessionId = () => {
  localStorage.getItem("session-id");
};

export const removeAllDetailsFromCurrentSession = () => {
  localStorage.removeItem("user-email-id");
  localStorage.removeItem("token");
  localStorage.removeItem("refresh-token");
};

export const getAccessToken = () => {
  const tmp = localStorage.getItem("token");
  if (!tmp) return null;
  return tmp.split(" ")[1];
}

export const setCsrfToken = (token) => {
  localStorage.setItem("csrf", token);
}

export const getCsrfToken = () => localStorage.getItem("csrf")

